<template>
  <div class="card flex flex-col flex-wrap p-1">
    <div class="flex flex-col">
      <h3>
        TOP COACHS
        <i
          class="fa fa-info-circle ml-05"
          v-tooltip="{
            content: 'Coachs ayant un taux de conversion supérieur à 66%.',
            placement: 'top',
          }"
        ></i>
      </h3>

      <AttributionsTreatedLevel
        id="successCoachs"
        type="success"
        :coachs="successCoachs"
      />
    </div>

    <div class="flex flex-col mt-3">
      <h3>
        MIDDLE COACHS
        <i
          class="fa fa-info-circle ml-05"
          v-tooltip="{
            content: 'Coachs ayant un taux de conversion entre 33% et 66%.',
            placement: 'top',
          }"
        ></i>
      </h3>

      <AttributionsTreatedLevel
        id="warningCoachs"
        type="warning"
        :coachs="warningCoachs"
      />
    </div>

    <div class="flex flex-col mt-3">
      <h3>
        BAD COACHS
        <i
          class="fa fa-info-circle ml-05"
          v-tooltip="{
            content: 'Coachs ayant un taux de conversion inférieur à 33%.',
            placement: 'top',
          }"
        ></i>
      </h3>

      <AttributionsTreatedLevel
        id="dangerCoachs"
        type="danger"
        :coachs="dangerCoachs"
      />
    </div>
  </div>
</template>

<script>
import AttributionsTreatedLevel from "@/components/coach-manager/attributions-treated/AttributionsTreatedLevel";

export default {
  components: {
    AttributionsTreatedLevel,
  },

  props: {
    coachs: {
      type: Array,
      required: true,
    },
  },

  computed: {
    successCoachs() {
      return this.coachs.filter((coach) => coach.ratio >= 66);
    },
    warningCoachs() {
      return this.coachs.filter(
        (coach) => coach.ratio >= 33 && coach.ratio < 66,
      );
    },
    dangerCoachs() {
      return this.coachs.filter((coach) => coach.ratio < 33);
    },
  },
};
</script>
